import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { QueryProvider } from '@/app/providers/QueryProvider';
import { RealtimeProvider } from '@/shared/lib/realtime';
import { AppErrorBoundary } from '@/shared/ui/feedback/AppErrorBoundary';
import { appRoutes } from '@/routes';

const router = createBrowserRouter(appRoutes);

const App = () => (
  <QueryProvider>
    <RealtimeProvider>
      <AppErrorBoundary>
        <RouterProvider router={router} />
      </AppErrorBoundary>
      <Toaster position="top-right" toastOptions={{ duration: 3500 }} />
    </RealtimeProvider>
  </QueryProvider>
);

export default App;
